import { DisplayValuesMap } from '~/common/types/data';
import { ServiceRequestStatus } from '~/common/types/serviceRequests';

export const serviceRequestStatusDisplayValues: DisplayValuesMap<ServiceRequestStatus> = {
  Complete: 'Complete',
  Raised: 'Raised',
  Cancelled: 'Cancelled',
};
